import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

// 公共路由
export const constantRoutes = [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: (resolve) => require(['@/views/redirect'], resolve)
      }
    ]
  },
  {
    path: '/login',
    component: (resolve) => require(['@/views/login'], resolve),
    hidden: true
  },
  {
    path: '/404',
    component: (resolve) => require(['@/views/error/404'], resolve),
    hidden: true
  },
  {
    path: '/401',
    component: (resolve) => require(['@/views/error/401'], resolve),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/index',
    children: [
      {
        path: 'index',
        component: (resolve) => require(['@/views/index'], resolve),
        name: '首页',
        meta: { title: '首页', icon: 'dashboard', noCache: true, affix: true }
      }
    ]
  },
  {
    path: '/user',
    component: Layout,
    hidden: true,
    redirect: 'noredirect',
    children: [
      {
        path: 'profile',
        component: (resolve) => require(['@/views/system/user/profile/index'], resolve),
        name: 'Profile',
        meta: { title: '个人中心', icon: 'user' }
      }
    ]
  },
  {
    path: '/dict',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'data/:type',
        component: (resolve) => require(['@/views/system/dictData'], resolve),
        name: 'DictData',
        meta: { title: '字典数据', icon: '' }
      }
    ]
  },
  {
    path: '/jobLog',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'index',
        component: (resolve) => require(['@/views/monitor/jobLog'], resolve),
        name: 'JobLog',
        meta: { title: '任务日志' }
      }
    ]
  },
  
  {
    path: '/dashboard1',
    component: Layout,
    redirect: '/dashboard1/index',
    children: [
      {
        path: 'index',
        component: (resolve) => require(['@/views/dashboard1/index'], resolve),
        name: 'Dashboard1',
      }
    ]
  },

  
    {
      path: '/editor-new',
      component: resolve => require(['@/views/ips/editor/editor-new'], resolve)
    },
    {
      path: '/editor',
      component: resolve => require(['@/views/ips/editor/index'], resolve)
    },
  {
    path: '*',
    redirect: '/404',
    hidden: true
  }
]

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

// 重置路由方法
export function resetRouter() {
  const newRouter = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
  })
  router.matcher = newRouter.matcher
}

export default router
